module.exports = __webpack_public_path__ + "img/c-rating.20ab0b5f.svg";